const actions = {
  LOAD_MEAGENDA_PLANS_REQUEST: 'MEAGENDA_PLANS_LOAD_REQUEST',
  MEAGENDA_PLANS_UPDATED: 'MEAGENDA_PLANS_UPDATED',
  MEAGENDA_PLANS_ERROR: 'MEAGENDA_PLANS_ERROR',

  loadMeagendaPlans: () => ({
    type: actions.LOAD_MEAGENDA_PLANS_REQUEST,
  }),
};

export default actions;
